var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"firstpage",staticStyle:{"margin-top":"-1px"}},[_c('img',{staticClass:"img-2",attrs:{"src":"/assets/~/media/images/activity/film2505-prod/mob/2.jpg","alt":""}}),_c('img',{staticClass:"img-3",attrs:{"src":"/assets/~/media/images/activity/film2505-prod/mob/3.jpg","alt":""}})])
}]

export { render, staticRenderFns }